import React, { useState } from 'react';
import axios from 'axios';
import '../Pincodefinder/Style.css';
import Logo from '../Logo/logo.png';

import '../assets/css/bootstrap.css';
import '../assets/css/animate.css';
import '../assets/css/swiper-bundle.css';
import '../assets/css/flaticon.css';
import '../assets/css/nouislider.css';
import '../assets/css/jquery-ui.css';
import '../assets/css/magnific-popup.css';
import '../assets/css/font-awesome-pro.css';
import '../assets/css/spacing.css';
import '../assets/css/main.css';


const Starlink = () => {
    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState<any[]>([]);
    const [currentStep, setCurrentStep] = useState(1);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    };

    const statusToStep: { [key: string]: number } = {
        'Booked': 1,
        'InTransit': 2,
        'DELIVERED': 3,
        'Delivered': 4,
    };

    const handleButtonClick = () => {
        setShowImage(!showImage);
    };

    const fetchData = async () => {
        try {
            const trimmedInputs = searchValue
                .split(',')
                .map((item) => item.trim())
                .filter((item) => item.length > 0);

            if (trimmedInputs.length === 0) {
                setError('Please enter one or more tracking numbers separated by commas.');
                return;
            }

            const awbNumbers = trimmedInputs.filter((item) => /^\d+$/.test(item));
            const refNumbers = trimmedInputs.filter((item) => /\D/.test(item));

            let queryParams: { awbNo?: string; refNo?: string } = {};

            if (awbNumbers.length > 0) {
                queryParams.awbNo = awbNumbers.join(',');
            }
            if (refNumbers.length > 0) {
                queryParams.refNo = refNumbers.join(',');
            }



            const res = await axios.get('http://localhost:2600/TrackingData?awbNo/TrackingData', {
                params: queryParams,
            });

            // const res = await axios.get('https://trackerex.com/TrackingSteelcityApi/TrackingData', {
            //     params: queryParams,
            // });

            const data = res.data;

            if (data?.status === 1 && Array.isArray(data.data)) {
                const tryImageExtensions = async (awbNo: string): Promise<string | null> => {
                    const extensions = ['jpg', 'jpeg', 'png'];
                    for (const ext of extensions) {
                        const url = `https://trackerex.com/PODImg/${awbNo}.${ext}`;
                        const exists = await checkImageExists(url);
                        if (exists) return url;
                    }
                    return null;
                };
            
                const checkImageExists = (url: string): Promise<boolean> => {
                    return new Promise((resolve) => {
                        const img = new Image();
                        img.src = url;
                        img.onload = () => resolve(true);
                        img.onerror = () => resolve(false);
                    });
                };
            
                const fetchImageLinks = async () => {
                    const updatedData = await Promise.all(data.data.map(async (item: any) => {
                        const imageUrl = await tryImageExtensions(item.awbNo);
                        return {
                            ...item,
                            ImageLink: imageUrl, // null if no image found
                        };
                    }));
            
                    setTrackingData(updatedData);
                    setError('');
                    setSearchValue('');
            
                    if (updatedData.length > 0) {
                        const status = updatedData[0].Status;
                        setCurrentStep(statusToStep[status] || 1);
                    }
                };
            
                fetchImageLinks();
            } else {
                setTrackingData([]);
                setError('Docket Not Found');
            }
            
        } catch (error: any) {
            console.error('Error:', error);
            setTrackingData([]);
            setError(
                error.response?.data?.message ||
                'Failed to fetch data. Please check your internet connection.'
            );
        }
    };

    return (
        <>

            <header>
                <div className="header-area d-none d-xl-block">
                    <div className="tpheader__top theme-background pt-5 pb-5 pl-160 pr-160">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xl-6">
                                    <div className="tpheader__social">
                                        <ul>
                                            <li>
                                                <a href="https://www.google.com/maps/@23.8223585,90.3661467,15z" target="_blank">
                                                    <i className="fa-sharp fa-solid fa-location-dot"></i>Andheri
                                                </a>
                                            </li>
                                            <li>
                                                <a href="mailto:starlinklogistics0@gmail.com">
                                                    <i className="flaticon-mail"></i>starlinklogistics0@gmail.com
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="tpheader d-flex justify-content-end ">
                                        <div className="tpheader__social">
                                            <ul>
                                                <li><a href="#">Help  </a></li>
                                                <li><a href="#">Support  </a></li>
                                                <li><a href="#">Contact</a></li>
                                            </ul>
                                        </div>
                                        <div className="tpheader__social">
                                            <ul>
                                                <li><a href="#"><i className="fa-brands fa-facebook-f"></i></a></li>
                                                <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
                                                <li><a href="#"><i className="fa-brands fa-linkedin-in"></i></a></li>
                                                <li><a href="#"><i className="fa-brands fa-twitter"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tpheader">
                        <div id="header-sticky" className="tpheader__bottom">
                            <div className="tpheader__bottom-wrap p-relative pr-160">
                                <div className="custom-container">
                                    <div className="tpheader__bottom-wrapp d-flex justify-content-between align-items-center">
                                        <div className="col-12 col-lg-6 text-center text-lg-start mb-3 mb-lg-0">
                                            <img
                                                src={Logo}
                                                alt="Company Logo"
                                                className="img-fluid"
                                                style={{ maxWidth: '500px', height: '100px' }}
                                            />
                                        </div>
                                        <div className="tpheader__bottom-right d-flex justify-content-between align-items-center">
                                            <div className="tpheader__main-menu mr-130">
                                                <div className="tpheader__main-menu main-menu">
                                                    <nav className="tp-main-menu-content">
                                                        <ul>
                                                            <li><a href="index.html">HOME</a></li>
                                                            <li><a href="about.html">ABOUT</a></li>
                                                            <li className="has-dropdown">
                                                                <a href="services.html">SERVICES</a>
                                                                <ul className="tp-submenu">
                                                                    <li><a href="services.html">Service</a></li>
                                                                    <li><a href="services-details.html">Service Details</a></li>
                                                                </ul>
                                                            </li>
                                                            <li><a href="documents.html">DOCUMENTS</a></li>
                                                            <li><a href="tracking.html">TRACKING</a></li>
                                                            <li><a href="contact.html">CONTACT</a></li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                            <div className="tpheader__header-right">
                                                <div className="tpheader__right text-end d-flex align-items-center justify-content-end">
                                                    <div className="tpheader__tracking-form d-flex align-items-center">
                                                        {/* <input
                              type="text"
                              placeholder="Enter AWB No."
                              style={{ height: '40px', padding: '0 10px', border: '1px solid #ccc', borderRadius: '5px', marginRight: '10px' }}
                            /> */}
                                                        {/* <button className="tp-btn" onClick={() => trackShipment()}>Tracking</button> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mobile-header tpheader__ptb d-xl-none pt-20 pb-20 p-relative ">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-6">
                                <div className="tpheader__main-logo">
                                    <div className="tpheader__logo p-relative z-index-2">
                                        <div className="tpoffcanvas__logo">
                                            <a href="/">
                                                <img src={Logo} alt="Company Logo" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mobile__menu d-flex align-items-center justify-content-end">
                                    <button className="search-open-btn mr-30 d-none d-sm-block">
                                        <i className="flaticon-loupe"></i>
                                    </button>
                                    <a className="tp-menu-bar" href="javascript:void(0)"><i className="fa-solid fa-bars"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>


            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="shadow p-4">
                            <input
                                type="text"
                                placeholder="Tracking Number(s)"
                                className="form-control mb-2 text-center border border-info"
                                value={searchValue}
                                onChange={handleInputChange}
                            />
                            <button onClick={fetchData} className="Track1 w-100">TRACK HERE</button>
                            {error && <div className="text-danger mt-2">{error}</div>}
                            <p className="mt-2">To track multiple AwbNo</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-9">
                        {trackingData.map((record, index) => (
                            <div key={index} className="shadow p-4 mb-4">
                                <h5 className="mb-3 text-center">Tracking Details</h5>
                                <table className="table table-bordered table-sm mb-4">
                                    <thead>
                                        <tr>
                                            <th>AwbNo</th>
                                            <th>Ref_No</th>
                                            <th>BookDate</th>
                                            <th>Consignee_Name</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{record.awbNo}</td>
                                            <td>{record.refNo || '-'}</td>
                                            <td>{record.bookDate}</td>
                                            <td>{record.consigneeName}</td>
                                            <td>{record.Status}</td>
                                        </tr>
                                    </tbody>
                                    <thead>
                                        <tr>
                                            <th>Qty</th>
                                            <th>Destination</th>
                                            <th>Receiver Name</th>
                                            <th>Delivery Date</th>
                                            <th>Delivery Time</th>
                                            {/* <th>Contact_No</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{record.Qty}</td>
                                            <td>{record.destinationName}</td>
                                            <td>{record.recvName}</td>
                                            <td>{record.DelvDT}</td>
                                            <td>{record.DelvTime}</td>
                                            {/* <td>{record.Destination_PIN}</td> */}
                                        </tr>

                                        <tr>
                                            {/* <th>Mobile_No</th>
                                            <td>{record.Destination_PIN}</td> */}
                                            <td colSpan={5}>
                                                <button className="btn btn-success" onClick={handleButtonClick}>
                                                    {showImage ? 'Hide Image' : 'Pod Image'}
                                                </button>
                                                {showImage && (
                                                    <div className="image-container mt-2 text-center">
                                                        <img src={record.ImageLink} alt="Podimages" className="img-fluid" />
                                                    </div>
                                                )}
                                            </td>

                                        </tr>
                                        <tr>

                                        </tr>


                                    </tbody>
                                </table>

                                <div className="w-100 position-relative" style={{ paddingBottom: '30px' }}>
                                    {/* Background Progress Line */}
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '15px',
                                            left: 0,
                                            right: 0,
                                            height: '4px',
                                            backgroundColor: '#ccc',
                                            zIndex: 0,
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${((currentStep - 1) / 2) * 100}%`, // since 3 steps → 2 gaps
                                                height: '100%',
                                                backgroundColor: '#007bff',
                                                transition: 'width 0.3s ease',
                                            }}
                                        ></div>
                                    </div>

                                    {/* Step Circles and Labels */}
                                    <div className="steps-container d-flex justify-content-between align-items-center my-3" style={{ position: 'relative', zIndex: 1 }}>
                                        {['Booked', 'InTransit', 'DELIVERED'].map((stepLabel, index) => {
                                            const normalizedLabel = stepLabel.toLowerCase();
                                            const stepNum = index + 1;
                                            const isActive = stepNum <= currentStep;

                                            return (
                                                <div key={normalizedLabel} className="text-center" style={{ flex: 1 }}>
                                                    <div
                                                        className={`step-circle ${isActive ? 'active' : ''}`}
                                                        style={{
                                                            width: '30px',
                                                            height: '30px',
                                                            borderRadius: '50%',
                                                            backgroundColor: isActive ? '#007bff' : '#ccc',
                                                            color: 'white',
                                                            lineHeight: '30px',
                                                            margin: '0 auto',
                                                            fontWeight: 'bold',
                                                        }}
                                                    >
                                                        {stepNum}
                                                    </div>
                                                    <div className="step-label mt-2">
                                                        {normalizedLabel.charAt(0).toUpperCase() + normalizedLabel.slice(1)}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>



                            </div>
                        ))}

                        {trackingData.map((record, index) => (
                            <div key={index} className="shadow p-4 mb-4">
                                <h5 className="mb-3 text-center"> Status Tracking </h5>
                                <table className="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            <th>Status Date</th>
                                            <th>Status Time</th>
                                            <th>Location Update</th>
                                            <th>Activity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {record.podHistory?.map((history: any, idx: number) => (
                                            <tr key={idx}>
                                                <td>{history.DelvDt}</td>
                                                <td>{history.DelvTime}</td>
                                                <td>{history.Destination_Name}</td>
                                                <td>{history.Remark}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <footer>
                <div className="footer-area theme-background pt-120 pb-80 p-relative fix">
                    <div className="tp-footer__car">
                        <img className="tp-footer__shape-1 movingX" src="assets/img/footer/footer-car.png" alt="" />
                    </div>

                    <div className="container">
                        <div className="row">
                            {/* Company Info */}
                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="tp-footer__widget class_Name mb-40">
                                    <a href="index.html" className="tp-footer__widget-logo">
                                        <h2 style={{ color: 'white', fontSize: '28px', fontWeight: 'normal', textDecoration: 'none' }}>
                                            StarLink
                                        </h2>
                                    </a>
                                    <div className="tp-footer__text mt-15 mb-25">
                                        <p style={{ textDecoration: 'none' }}>
                                            Desires to obtain pain of it because it is pain, but occasionally circum
                                        </p>
                                    </div>
                                    <div className="tp-footer__contact-info tp-footer__icon-space">
                                        <ul>
                                            <li>
                                                <span><i className="fa-solid fa-square-phone"></i></span>
                                                <a href="tel:+918452973314" style={{ textDecoration: 'none' }}>
                                                    +918452973314 / 7977919910 / 9321756691
                                                </a>
                                            </li>
                                            <li>
                                                <span><i className="fa-sharp fa-solid fa-envelope"></i></span>
                                                <a href="mailto:starlinklogistics0@gmail.com" style={{ textDecoration: 'none' }}>
                                                    starlinklogistics0@gmail.com
                                                </a>
                                            </li>
                                            <li>
                                                <span><i className="flaticon-location"></i></span>
                                                <a href="#" target="_blank" style={{ textDecoration: 'none' }}>
                                                    Office C 2, Ground Floor, Opp. Samraj Hotel, Chakala Road, Chakala, Andheri (E), Mumbai-400099
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Navigation */}
                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="tp-footer__widget mb-40">
                                    <h4 className="tp-footer__widget-title" style={{ textDecoration: 'none' }}>Our Navigation</h4>
                                    <div className="tp-footer__content">
                                        <ul>
                                            {['Home', 'About', 'Services', 'Tracking', 'Documents', 'Contact'].map((item) => (
                                                <li key={item}>
                                                    <a href="#" style={{ textDecoration: 'none' }}>
                                                        <i className="fa-sharp fa-solid fa-plus"></i> {item}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Services */}
                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="tp-footer__widget mb-40">
                                    <h4 className="tp-footer__widget-title" style={{ textDecoration: 'none' }}>Our Services</h4>
                                    <div className="tp-footer__content">
                                        <ul>
                                            {['Surface Freight', 'Air Freight', 'Rail Freight', 'Warehousing', 'Custom Clearance'].map((service) => (
                                                <li key={service}>
                                                    <a href="#" style={{ textDecoration: 'none' }}>
                                                        <i className="fa-sharp fa-solid fa-plus"></i> {service}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Map */}
                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="tp-footer__widget">
                                    <h4 className="tp-footer__widget-title" style={{ textDecoration: 'none' }}>Find Us on Map</h4>
                                    <div className="tp-footer__map">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=..."
                                            width="100%"
                                            height="200"
                                            style={{ border: 0 }}
                                            allowFullScreen
                                            loading="lazy"
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="tp-footer__bottom pt-25 pb-25">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-6 col-lg-6 col-md-7 col-12">
                                <div className="tp-footer__copyright text-md-start text-center">
                                    <p style={{ textDecoration: 'none' }}>
                                        Copyright © 2025 StarLinkCouriers Designed by
                                        <a href="#" style={{ textDecoration: 'none' }}> Neotech It Services.</a> All Rights Reserved
                                    </p>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-lg-6 col-md-5 col-12">
                                <div className="tp-footer__menu text-md-end text-center">
                                    <ul>
                                        <li><a href="#" style={{ textDecoration: 'none' }}>Terms of Use</a></li>
                                        <li><a href="#" style={{ textDecoration: 'none' }}>Privacy Policy</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Starlink;









